import React from "../../__compat__/react/main.entry.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { useSpacing } from "../../index.mjs.mjs";
import { StyledRoot, StyledCircularLoader, StyledLoaderContainer, StyledValue, StyledLabel, StyledProgressBar, StyledProgressBarTrain, circularLoaderSizes, StyledCircularTrain, StyledCircularTrack, } from "./Loader.styles.mjs.mjs";
let labelId = 0;
const getLabelId = () => {
    return `Loader-Label-${labelId++}`;
};
export const Loader = React.forwardRef(({ size = 'large', variant = 'circular', monochrome = false, value = null, displayValue, inverted = false, label, 'aria-labelledby': ariaLabelledBy, 'aria-label': ariaLabel, ...restProps }, ref) => {
    let determinate = false;
    let progress;
    if (typeof value === 'number') {
        determinate = true;
        value = Math.max(Math.min(Math.round(value), 100), 0);
        displayValue = displayValue || value.toString();
        progress = value / 100;
    }
    const progressType = determinate
        ? 'determinate'
        : 'continuous';
    const generatedLabelId = label && !(ariaLabelledBy || ariaLabel) ? getLabelId() : undefined;
    const resolvedAriaLabelledBy = ariaLabelledBy || generatedLabelId;
    const contextualProps = {
        ...(resolvedAriaLabelledBy
            ? { 'aria-labelledby': resolvedAriaLabelledBy }
            : { 'aria-label': ariaLabel }),
        ...(typeof value === 'number' && {
            'aria-valuenow': value,
            'aria-valuemin': 0,
            'aria-valuemax': 100,
        }),
        ...(displayValue && { 'aria-valuetext': displayValue }),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
        ...pickComponentCommonProps(restProps),
    };
    return (React.createElement(StyledRoot, { ...contextualProps, inverted: inverted, role: "progressbar", title: displayValue, variant: variant, outerSpacing: useSpacing(restProps), ref: ref },
        React.createElement(StyledLoaderContainer, { monochrome: inverted || monochrome, inverted: inverted, progress: progress, progressType: progressType, size: size, variant: variant }, (() => {
            switch (variant) {
                case 'circular': {
                    const dimensions = circularLoaderSizes[progressType][size];
                    const radius = dimensions.diameter / 2;
                    const svgCircleParameters = {
                        cx: radius,
                        cy: radius,
                        r: radius - dimensions.stroke / 2,
                    };
                    return (React.createElement(React.Fragment, null,
                        React.createElement(StyledCircularLoader, { progressType: progressType, viewBox: `0 0 ${dimensions.diameter} ${dimensions.diameter}` },
                            React.createElement(StyledCircularTrack, { ...svgCircleParameters }),
                            React.createElement(StyledCircularTrain, { progressType: progressType, ...svgCircleParameters })),
                        determinate && (React.createElement(StyledValue, { role: "presentation", size: size }, displayValue))));
                }
                case 'linear':
                    return (React.createElement(StyledProgressBar, null,
                        React.createElement(StyledProgressBarTrain, { progressType: progressType })));
            }
        })()),
        label && (React.createElement(StyledLabel, { id: generatedLabelId, variant: variant }, label))));
});
Loader.displayName = 'Loader';
//# sourceMappingURL=Loader.mjs.mjs.map